import moment, { Moment } from "moment";
import { DatePostProperties, FormatOptions, MomentFormat, FormatValue, CapitalizeEnum } from "@/services/posts/postTypes/date";

function capitalize(text: string, capitalization: CapitalizeEnum) {
    switch (capitalization) {
    case CapitalizeEnum.FirtLetterCapital:
        return text.charAt(0).toUpperCase() + text.slice(1);
    case CapitalizeEnum.LowerCase:
        return text.toLowerCase();
    default:
        return text;
    }
}

function formattedDate(date: Moment, format: FormatValue) {
    if (!format.format) {
        return "";
    }
    return capitalize(date.format(format.format), format.capitalize);
}

export function renderDate(date: Moment, properties: DatePostProperties, utcOffset: string) {
    var date = moment(date).utcOffset(utcOffset);
    date.locale(properties.language);
    return (properties.dateFormat.textOne + formattedDate(date, properties.dateFormat.dateOptionOne) +
        properties.dateFormat.textTwo + formattedDate(date, properties.dateFormat.dateOptionTwo) +
        properties.dateFormat.textThree + formattedDate(date, properties.dateFormat.dateOptionThree) +
        properties.dateFormat.textFour + formattedDate(date, properties.dateFormat.dateOptionFour) +
        properties.dateFormat.textFive).trim();
}
